import { observer } from 'mobx-react-lite'
import { lazy, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'

import { useStore } from 'store/useStore'
import { ContainerLK } from 'sections/LKSection/shared/components/ContainerLK/ContainerLK'
import { Margin, Padding, ReactSelect } from 'components/ui'
import { Button, Flex, Form, FormItem, Paragraph, Title } from 'components/uiKit'
import { useResize } from 'utils/hooks/useResize'
import { BaseOption } from 'shared/types/types'

import { ContactInfoStep } from '../../components/PersonalDataSteps/ContactInfoStep/ContactInfoStep'
import { citizenshipOptions } from '../../data'
import { Citizenship } from '../../types'

const EditContactPage = observer(() => {
  const { profileUiStore: uiStore } = useStore()
  const [isVisibleAskForm, setVisibleAskForm] = useState<boolean>(true)
  const { companyDetails } = uiStore
  const { isMobile } = useResize()
  const navigate = useNavigate()

  useEffect(() => {
    uiStore.createEditData()
    return () => {
      setVisibleAskForm(true)
      companyDetails.clearCompanyInfo()
    }
  }, [])

  const backButtonHandler = () => {
    navigate(-1)
  }

  const handleUpdateContact = () => {
    uiStore.apiStore.updateContact().then(() => {
      navigate(-1)
    })
  }

  const handleChangeCitizenship = (item: BaseOption<Citizenship>) => {
    companyDetails.setSelectedCitizenship(item)
  }

  return (
    <ContainerLK>
      <Padding py={32}>
        <Margin mt={isMobile ? 0 : 50} mb={isMobile ? 40 : 80}>
          <Flex gap={16} align="center">
            <Button shape="circle" icon={<ArrowLeftOutlined />} onClick={backButtonHandler} />
            <Title>Редактирование контактной информации</Title>
          </Flex>
        </Margin>
        <Margin mt={32}>
          {isVisibleAskForm && (
            <>
              <Form style={{ maxWidth: 600, marginTop: 50 }}>
                <Paragraph>Выберите параметры указанные при регистрации</Paragraph>
                <FormItem label={'Гражданство'}>
                  <ReactSelect
                    placeholder={'Выберите гражданство'}
                    options={citizenshipOptions}
                    value={citizenshipOptions.find(
                      (option) => option.value === companyDetails.selectedCitizenship.value,
                    )}
                    onChange={(citizenship) => handleChangeCitizenship(citizenship as BaseOption<Citizenship>)}
                  />
                </FormItem>
                <Button onClick={() => setVisibleAskForm(false)} loading={uiStore.loadingPassportData}>
                  Получить форму для редактирования
                </Button>
              </Form>
            </>
          )}

          {!isVisibleAskForm && (
            <>
              <ContactInfoStep
                profile={uiStore.profile}
                citizenship={uiStore.companyDetails.selectedCitizenship.value}
              />
              <Margin mt={20}>
                <Flex gap={20}>
                  <Button type={'default'} onClick={() => setVisibleAskForm(true)}>
                    Назад
                  </Button>
                  <Button
                    onClick={handleUpdateContact}
                    loading={uiStore.isSendingData}
                    disabled={uiStore.validateStore.isInvalidContactInfo || uiStore.isSendingData}
                  >
                    Обновить
                  </Button>
                </Flex>
              </Margin>
            </>
          )}
        </Margin>
      </Padding>
    </ContainerLK>
  )
})

export default EditContactPage

export const EditContactPageAsync = lazy(() => import('./EditContactPage'))
